import { Encumbrance } from 'types';

const toDayString = (value?: string | Date | null): string | null => {
  if (value == null) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString().slice(0, 10);
};

const compareDates = (
  a?: string | Date | null,
  b?: string | Date | null
): number => {
  const dayA = toDayString(a);
  const dayB = toDayString(b);

  if (dayA === null && dayB === null) return 0;
  if (dayA === null) return -1;
  if (dayB === null) return 1;

  if (dayA < dayB) return -1;
  if (dayA > dayB) return 1;
  return 0;
};

type IsActiveEncumbranceProps = {
  encumbrance: Partial<Encumbrance> & Pick<Encumbrance, 'endDate'>;
};

export const isActiveEncumbrance = ({
  encumbrance,
}: IsActiveEncumbranceProps): boolean => {
  const endDate = encumbrance?.endDate;

  if (toDayString(endDate) === null) return true;

  return compareDates(endDate, new Date()) >= 0;
};
